/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetNewsList200ResponseDataArticlesInner } from './GetNewsList200ResponseDataArticlesInner'
import {
  GetNewsList200ResponseDataArticlesInnerFromJSON,
  GetNewsList200ResponseDataArticlesInnerFromJSONTyped,
  GetNewsList200ResponseDataArticlesInnerToJSON,
} from './GetNewsList200ResponseDataArticlesInner'
import type { GetNewsList200ResponseDataCategoriesInner } from './GetNewsList200ResponseDataCategoriesInner'
import {
  GetNewsList200ResponseDataCategoriesInnerFromJSON,
  GetNewsList200ResponseDataCategoriesInnerFromJSONTyped,
  GetNewsList200ResponseDataCategoriesInnerToJSON,
} from './GetNewsList200ResponseDataCategoriesInner'

/**
 *
 * @export
 * @interface GetNewsList200ResponseData
 */
export interface GetNewsList200ResponseData {
  /**
   * Карточки новостей (только опубликованные, по дате публикации по убыванию)
   * @type {Array<GetNewsList200ResponseDataArticlesInner>}
   * @memberof GetNewsList200ResponseData
   */
  articles: Array<GetNewsList200ResponseDataArticlesInner>
  /**
   * Категории новостей (в порядке sort_order)
   * @type {Array<GetNewsList200ResponseDataCategoriesInner>}
   * @memberof GetNewsList200ResponseData
   */
  categories: Array<GetNewsList200ResponseDataCategoriesInner>
}

/**
 * Check if a given object implements the GetNewsList200ResponseData interface.
 */
export function instanceOfGetNewsList200ResponseData(
  value: object
): value is GetNewsList200ResponseData {
  if (!('articles' in value) || value['articles'] === undefined) return false
  if (!('categories' in value) || value['categories'] === undefined)
    return false
  return true
}

export function GetNewsList200ResponseDataFromJSON(
  json: any
): GetNewsList200ResponseData {
  return GetNewsList200ResponseDataFromJSONTyped(json, false)
}

export function GetNewsList200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetNewsList200ResponseData {
  if (json == null) {
    return json
  }
  return {
    articles: (json['articles'] as Array<any>).map(
      GetNewsList200ResponseDataArticlesInnerFromJSON
    ),
    categories: (json['categories'] as Array<any>).map(
      GetNewsList200ResponseDataCategoriesInnerFromJSON
    ),
  }
}

export function GetNewsList200ResponseDataToJSON(
  value?: GetNewsList200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    articles: (value['articles'] as Array<any>).map(
      GetNewsList200ResponseDataArticlesInnerToJSON
    ),
    categories: (value['categories'] as Array<any>).map(
      GetNewsList200ResponseDataCategoriesInnerToJSON
    ),
  }
}
